// Utils
import makeSelectOptionsSelector from 'fc-utils/makeSelectOptionsSelector'

// Constants
import {
  PROP_LABEL,
} from 'fc-model-assets'

// Selectors
import { farms$ } from 'fc-assets'

// Exports
export default makeSelectOptionsSelector(PROP_LABEL)(farms$)
